export default {
    orderProperties: {
        products: [],
        objectTypes: [],
        contactInfo: {
            ownerFirstName: '',
            ownerLastName: '',
            ownerSecondaryPhoneNumber: '',
            ownerPrimaryPhoneNumber: '',
            ownerEmailAddress: ''
        },
        addressInfo: {
            addressLine1: '',
            addressCity: '',
            addressPostalNumber: '',
            addressDistrict: '',
            objectAreaSquareMeters: '',
            objectNumberOfRooms: '',
            objectType: 0,
            apartmentHasBalcony: null,
            apartmentFloor: '',
            apartmentAccessCode: ''
        },
        orderOtherInfo: {
            notes: '',
            extraDeliveryRecipients: '',
            contactPerson: null,
            willOrderCreatorAttendWhenPhotographing: false,
            preferredTimeOfPhotographing: null
        },
        availableBrokerAgents: []
    }
};
